import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Arquivo } from '../interface/arquivo';
import { UtilService } from './util';

@Injectable({
  providedIn: 'root'
})
export class ArquivoService {
  url = `${environment.urlGestaoArquivo}/api/arquivo`;

  constructor(
    private http: HttpClient,
    private utilService: UtilService,
  ) {}

  postArquivoAtualizaDados(dadosAtualizar: any) {
    let httpOptions = this.utilService.filtrosHttpOptions({},false,false);
    return this.http.post(`${this.url}/atualiza/generico/`, dadosAtualizar,httpOptions);
  }

  getArquivoLista(empresa: string, filial: string, alias: string, chave: string, tipo: string) {
    let httpOptions = this.utilService.filtrosHttpOptions({chave,tipo},false,false);
    return this.http.get<any[]>(`${this.url}/lista/generico/${empresa}/${filial}/${alias}`,httpOptions);
  }

  deleteArquivo(id: number) {
    let httpOptions = this.utilService.filtrosHttpOptions({},false,false);
    return this.http.delete(`${this.url}/generico/${id}`, httpOptions);
  }

  getArquivo(id: number): Observable<Arquivo> {
    let httpOptions = this.utilService.filtrosHttpOptions({},false,false);
    return this.http.get<Arquivo>(`${this.url}/binario/${id}`,httpOptions);
  }
}
